<ng-template #fieldsTmpl>
  <rt-dropdown-header>
    <rt-icon-button
      prefix
      [iconName]="'arrow-back'"
      size="small"
      variant="plain"
      (click)="mainDropdown.prevTemplate()"
    />
    {{ 'app.views.view_settings.properties' | translate }}
  </rt-dropdown-header>
  <rt-input
    [formControl]="fieldsSearch"
    [placeholder]="'app.views.view_settings.properties_search_placeholder' | translate"
    class="search"
    margin-tb-small-x
    margin-lr-small
  >
    <rt-icon prefix name="search" />
  </rt-input>
  <div
    cdkDropList
    cdkDropListLockAxis="y"
    (cdkDropListDropped)="onFieldsReorder($event)"
    class="items drag-boundary"
  >
    @for (field of visibleFields; track field.id) {
      <rt-dropdown-item
        [hasHoverEffect]="field.editable"
        cdkDrag
        cdkDragBoundary=".drag-boundary"
        [cdkDragDisabled]="layoutControl().value!.type !== 'table'"
        (click)="toggleField(field)"
      >
        <rt-checkbox
          prefix
          [checked]="field.selected"
          [disabled]="!field.editable"
          (valueChange)="toggleField(field)"
        />
        <div layout layout-space-between layout-align-items-center>
          <span text-darkest text-semi-medium>{{ field.label }}</span>
          @if (layoutControl().value!.type === 'table') {
            <rt-icon name="drag-vertical" [hasAutoHeight]="true" />
          }
        </div>
      </rt-dropdown-item>
    }
  </div>
</ng-template>

<rt-dropdown-item [targetFor]="fieldsTmpl" (click)="viewsAnalytics.settingsPropertiesOpen()">
  <rt-icon prefix name="playlist-add" />
  <div layout-vertical>
    <div layout layout-space-between>
      <span>{{ 'app.views.view_settings.properties' | translate }}</span>
      <rt-icon name="chevron-right" />
    </div>
    <span text-small text-weight-default text-color class="description">
      {{
        'app.views.view_settings.properties_counters'
          | translate
            : {
                visible: selectedFieldsCount,
                hidden: availableFieldsCount - selectedFieldsCount,
              }
      }}
    </span>
  </div>
</rt-dropdown-item>
